/**
 * @LocalStorage Authentication variable
 */
export const LOCALSTORAGE_AUTH = 'userAuth';

/** Default password for signup */
export const DEFAULT_PASSWORD = 'test12';
